<template>
  <Modal
    ref="modal"
    title="Advertising Change Request"
    action="Submit"
    actionColor="indigo"
    @closeModal="handleCancel"
    @handleAction="submitChangeRequest"
  >
    <div
      class="bg-gray-100 text-gray-900 p-4 lg:flex items-center justify-left gap-2 rounded-lg my-8 text-center lg:text-left"
    >
      <div>
        <header class="font-bold">Reminder</header>
        <p class="mt-1">
          Changes to Advertising and Billing are made at the 1st of each month. If you request a change mid-month, the
          changes will be reflected at the beginning of the next month.
        </p>
        <header class="mt-2 font-bold">Current Total Spend</header>
        <p class="mt-1">${{ currentTotalSpend }}</p>
      </div>
    </div>
    <CurrencyInput class="mt-4" label="Newly Requested Amount" :modelValue="totalSpend" />
    <TextAreaInput
      class="mt-4"
      label="Change Request Reason"
      :optional="true"
      :modelValue="changeReason"
      @update:modelValue="changeReason = $event"
    />
    <CheckboxInput
      class="mt-4"
      label="By submitting this advertising change request, you are consenting to the advertising management fee set forth in your contract."
      :modelValue="managementAgreement"
      @update:modelValue="managementAgreement = $event"
    />
    <p class="mt-4 text-xs text-center leading-5 text-gray-500">
      This form submission is governed by Humaniz, Inc.'s
      <a href="https://www.humaniz.io/advertising-management-terms-of-service" target="_blank"
        >Terms and Conditions for Ad Management Services</a
      >.
    </p>
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';

export default {
  props: ['currentTotalSpend'],
  components: {
    Modal,
  },
  data() {
    return {
      totalSpend: 0,
      changeReason: '',
      managementAgreement: false,
    };
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.$emit('handleCancel');
    },
    submitChangeRequest() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/monthly_marketing_budget_update_requests`, {
        method: 'POST',
        body: JSON.stringify({
          total_spend: self.totalSpend,
          indeed_spend: 0,
          zip_spend: 0,
          monster_spend: 0,
          meta_spend: 0,
          reason: self.changeReason,
          management_fee_consent: this.managementAgreement,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Advertising change request submitted',
              alertDescription:
                'Your Advertising change request was successfully submitted.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Advertising change request error',
              alertDescription: data.message,
            });
          }
          this.$emit('handleSave');
        });
    },
  },
};
</script>
